/**
 * Stripe Configuration
 *
 * Note: Stripe SDK and checkout are now handled by the centralized payment gateway.
 * This file only contains utility functions for currency and pricing formatting.
 */

// Currency configuration
export type Currency = 'USD' | 'CAD';
export const SUPPORTED_CURRENCIES: Currency[] = ['USD', 'CAD'];

// Get user's default currency based on locale or preference
export const getDefaultCurrency = (): Currency => {
  const userLocale = navigator.language || navigator.languages?.[0];
  const country = userLocale?.split('-')[1];
  return country === 'CA' ? 'CAD' : 'USD';
};

// Helper function to format price
export const formatPrice = (price: number, currency: string = 'USD'): string => {
  if (price === 0) return 'Free';
  
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 0
  }).format(price);
};

// Feature availability check based on plan hierarchy
export const isFeatureAvailable = (
  userPlan: string,
  requiredPlan: string
): boolean => {
  const planHierarchy = ['starter', 'professional', 'business'];
  const userPlanIndex = planHierarchy.indexOf(userPlan);
  const requiredPlanIndex = planHierarchy.indexOf(requiredPlan);
  
  return userPlanIndex >= requiredPlanIndex;
};

// Note: All pricing data is now dynamically loaded via the usePricing hook
// from the backend single point of truth system. No hard-coded prices remain.